import React from 'react';

import "./CSS/LoginPage.css";
import "./CSS/Dashboard.css";
import "./CSS/Project-Form.css";
import "./CSS/DataTable.css";
import "./CSS/media.css";

import Main from './components/Main';

function App() {
  return (
    <>
       <Main />
    </>
  ); 
}

export default App;
